import { useState,useEffect } from 'react';
import Card from '../../components/card'
import Gif from '../../img/questions.gif'
import GifBad from '../../img/bad.gif'
import GifMedium from '../../img/medium.gif'
import GifGood from '../../img/good.gif'
import ribbon from './ribbon.svg'
import Badge from '../../components/badge';
import {useLayoutContext} from '../../context/game'

export default function Title({title,description,optionCount,setRoute}){
	const [context] = useLayoutContext();
	const isOver = context?.disabled?.length === optionCount && !!optionCount;
	const [correct,setCorrect] = useState(0);
	const [gif, setGif] = useState(GifGood);
	useEffect(()=>{
		const {answeredList} = context;
		if(!answeredList) return;
		const answeredCorrectly = Object.keys(answeredList).reduce((agr,qId)=>{
			const aId = answeredList[qId];
			const correctId = window.game_data?.answers[qId];
			if(aId === correctId){
				return agr + 1
			}
			return agr;
		},0)
		setCorrect(answeredCorrectly);
		if (answeredCorrectly === 0){
			setGif(GifBad)
			return;
		}
		if (optionCount === 1 && answeredCorrectly === 0){
			setGif(GifBad)
			return;
		}
		const successRate = Math.floor(100*answeredCorrectly/optionCount);
		if (successRate < 34){
			setGif(GifBad)
		}else if(successRate >= 34 && successRate < 65){
			setGif(GifMedium)
		}else if(successRate >= 66){
			setGif(GifGood)
		}
	},[context?.answeredList?.length])
	return(
		<div className="row g-0 py-5 position-relative flex-grow-1">
			<div className='game-bg'></div>
			<div className="col-lg-8 col-xl-6 mx-auto px-3">
				<Card className='start-end'>
					{
						isOver?(
							<div className="text-center d-flex flex-column align-items-center" style={{marginBottom:24}}>
								<h2 className='mb-0 mt-2 fw-600'>
									Žaidimas baigtas!
								</h2>
								<img className='gif-emotion' src={gif} alt="X" />
								<h5 className='mt-4 mb-n4'>Teisingai atsakėte į {correct} iš {optionCount} klausimų</h5>
							</div>
						):(
							<img className='gif' src={Gif} alt="X" />
						)
					}

					<div className="py-4">
						<h2 className='vpe-card-title'>{title}</h2>
						{description && (
							<div className='vpe-card-description' dangerouslySetInnerHTML={{__html:description}}></div>
						)}
					</div>
					<div className="row">
						<div className="col-xl-6 col-lg-8 mx-auto">{isOver?<EndBtn/>:<StartBtn />}</div>
					</div>
				</Card>
			</div>
		</div>
	)
	function StartBtn(){
		return(
			<button type="button" onClick={()=>{setRoute('questions');}} className='btn btn-secondary w-100 mb-4' style={{padding:'0.5rem 1rem'}}>
				{
					context?.disabled?.length > 0 
					?'Tęsti'
					:'Pradėti'
				}
			</button>
		)
	}
	function EndBtn(){
		const blockBtn = {
			display:'block',
			width:'100%',
			padding:'0.5rem 1rem'
		}
		return(
			<div>
				{window?.global_data?.knowledge?.content && (
					<button type='button' onClick={()=>{setRoute("knowledge")}} style={blockBtn} className="btn btn-secondary mb-4">
						Sužinok
						<img src={ribbon} className="ms-2" alt="M" />
					</button>
				)}
				{window?.global_data?.knowledge?.url && (
					UrlButton()
				)}

				<button style={blockBtn} className="btn btn-outline-secondary mb-4" onClick={()=>{setRoute('answers')}} >
					Peržiūrėti atsakymus
					<svg className="ms-2" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M8 0.5H18V2.5H8V0.5ZM8 4.5H14V6.5H8V4.5ZM8 10.5H18V12.5H8V10.5ZM8 14.5H14V16.5H8V14.5ZM0 0.5H6V6.5H0V0.5ZM2 2.5V4.5H4V2.5H2ZM0 10.5H6V16.5H0V10.5ZM2 12.5V14.5H4V12.5H2Z" fill="currentColor"/>
					</svg>

				</button>
				<button style={blockBtn} className="btn btn-outline-secondary" onClick={()=>{window.location.reload()}}>
					Iš naujo
					<svg className="ms-2" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M20.3444 21.0804C18.1669 22.9672 15.3812 24.004 12.5 24C5.8724 24 0.5 18.6276 0.5 12C0.5 5.3724 5.8724 0 12.5 0C19.1276 0 24.5 5.3724 24.5 12C24.5 14.5632 23.696 16.9392 22.328 18.888L18.5 12H22.1C22.0998 9.78744 21.3354 7.64287 19.936 5.92907C18.5366 4.21526 16.5882 3.03743 14.4204 2.59483C12.2526 2.15223 9.99839 2.47202 8.03921 3.50012C6.08003 4.52821 4.53611 6.20149 3.66863 8.23689C2.80115 10.2723 2.66337 12.5449 3.27859 14.6702C3.89381 16.7955 5.22427 18.643 7.0449 19.9003C8.86552 21.1575 11.0645 21.7473 13.27 21.5699C15.4754 21.3924 17.5518 20.4586 19.148 18.9264L20.3444 21.0804Z" fill="currentColor"/>
					</svg>
	
				</button>
			</div>
		)

		function UrlButton() {
			let url = window.global_data.knowledge.url;
			let url_regex = new RegExp(/^https?:\/\//);

			if(!url_regex.test(url)){
				url = 'http://' + url;
			}

			return <a href={url} target="_blank" rel="noopener noreferrer" style={blockBtn} className="btn btn-secondary mb-4">
				Sužinok
				<img src={ribbon} className="ms-2" alt="M" />
			</a>;
		}
	}
}


